/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

export function isNotEmpty(item: unknown[] | string): boolean {
  return item.length > 0;
}

export function isEmpty(item: unknown[] | string): boolean {
  return !isNotEmpty(item);
}

export function isNotEmptyObj(item: Record<string, unknown>): boolean {
  return isNotEmpty(Object.keys(item));
}

export function isEmptyObj(item: Record<string, unknown>): boolean {
  return !isNotEmptyObj(item);
}
